import { render, staticRenderFns } from "./PlatformIcon.vue?vue&type=template&id=1aa357bd"
import script from "./PlatformIcon.vue?vue&type=script&lang=js"
export * from "./PlatformIcon.vue?vue&type=script&lang=js"
import style0 from "./PlatformIcon.vue?vue&type=style&index=0&id=1aa357bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports